import { AbstractControl, FormGroup } from '@angular/forms';

type FormControls = Record<string, AbstractControl<any>>;
export type FormGroupType<T> = FormGroup<{ [K in keyof T]: AbstractControl<T[K]> }>;

export function createFormGroup<T>(controls: FormControls = {}): FormGroup<{ [K in keyof T]: AbstractControl<T[K]> }> {
  return new FormGroup<any>(controls);
}

export function getDirtyValues<T = Record<string, any>>(form: FormGroup): Partial<T> {
  return Object.entries(form.controls).reduce<Record<string, unknown>>((values, [key, control]) => {
    if (control.dirty) {
      values[key] = control instanceof FormGroup ? getDirtyValues(control) : (control.value ?? null);
    }
    return values;
  }, {}) as Partial<T>;
}
